import React, {Component} from 'react';
import { Col, Label, Input, FormGroup } from "reactstrap";
import _ from 'lodash';

export default class FormInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            alerta: this.props.alerta,
            limiteInput: false,
            value: ""
        };
    }

    componentDidMount(){
        if (_.get(this.props.objeto, this.props.dado))
        {
            this.setState({
                value: _.get(this.props.objeto, this.props.dado)
            })
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.alerta !== this.props.alerta) {
            this.setState({
                alerta: this.props.alerta
            });
        }
    };

    handleChange = (event) => {
        if (this.props.sanitizar) {
            event.target.value = this.props.sanitizar(event.target.value);
        }
        this.props.onChange(event, event);
        if(this.props.limiteMaximo){
            if(event.target.value.length <= this.props.limiteMaximo){
                this.setState({
                    alerta: "",
                    limiteInput : false,
                    value: event.target.value
                })
            }
        }else{
            this.setState({
                value: event.target.value
            })
        }
    }

    handleBlur = (event) => {
        if (this.props.sanitizar) {
            event.target.value = this.props.sanitizar(event.target.value);
        }
        let invalido = (this.props.validador) ? this.props.validador(event.target.value) : false;
        
        if(invalido && this.props.validacaoStore){
            this.props.validacaoStore(false)
        }
        this.setState({
            alerta: invalido
        });

        if (event.target.value === null || event.target.value.length === 0) {
            this.salva(event);
            return
        }
        
        let removeString = /[/.-]/g;
        let val = "";

        //CNPJ
        if ( (/^[A-Z0-9]{2}\.?[A-Z0-9]{3}\.?[A-Z0-9]{3}\/?[A-Z0-9]{4}\-?[0-9]{2}$/gi).test(event.target.value) || (/^\-?[A-Z0-9]*$/gi).test(event.target.value) )
        {   
            val = event.target.value.replace(removeString,"");
            event.target.value = val;
            this.setState({
                alerta: "",
                limiteInput : false,
                value: val
            });
            if(this.props.limiteMaximo){
                if(event.target.value.length <= this.props.limiteMaximo){
                    this.setState({
                        alerta: "",
                        limiteInput : 14,
                        value: val
                    })
                }
            }
        }
        //CPF
        else if ( (/^[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}$/g).test(event.target.value) || (/^\-?[0-9]*$/g).test(event.target.value) )
        {   
            val = event.target.value.replace(removeString,"");
            event.target.value = val;
            if(this.props.limiteMaximo){
                if(event.target.value.length <= this.props.limiteMaximo){
                    this.setState({
                        alerta: "",
                        value: val
                    })
                }
            }else{
                this.setState({
                    alerta: "",
                    value: val
                })
            }
        }
        else {
            invalido = true;
            if (this.props.validacaoStore){
                this.props.validacaoStore(false);
            }   
            if (event.target.value.length > 0) {         
                this.setState({
                    alerta: "Formato inválido",
                    limiteInput: false,
                    value: val
                })
            }
        }

        if (!invalido) {
            this.salva(event);
            this.props.validacaoStore && this.props.validacaoStore(true)
        } 
    }
    
    salva = (event) => {
        this.props.onChange(event, event)
        if (this.props.onBlur) {
            this.props.onBlur(_.get(this.props.objeto, this.props.dado));
        }
    }

    render() {
        return(            
             <Col className={this.props.className ? this.props.className+" form-input-simples" : "form-input-simples"}
                xs={this.props.xs ? this.props.xs : 'auto'}
                sm={this.props.sm ? this.props.sm : 'auto'}
                md={this.props.md ? this.props.md : 'auto'}
                lg={this.props.lg ? this.props.lg : 'auto'}
                xl={this.props.xl ? this.props.xl : 'auto'}>
                <FormGroup className="mb-0">
                    { this.props.titulo && <Label>{ this.props.titulo } { this.props.obrigatorio ? <span className="label-danger">*</span> : "" } </Label> }
                    <Input defaultValue= { this.props.value ? this.props.value : _.get(this.props.objeto, this.props.dado) }
                        value={this.state.value ? this.state.value : _.get(this.props.objeto, this.props.dado) }
                        className={ this.props.uppercase ? 'uppercase' : '' }
                        disabled = {this.props.bloqueado ? "disabled" : ""}
                        placeholder={this.props.placeholder ? this.props.placeholder : ""}
                        type="text"
                        min={ this.props.min ? this.props.min : 0 } max={ this.props.max ? this.props.max : 999999 }
                        onChange={ this.handleChange }
                        maxLength={this.state.limiteInput ? this.state.limiteInput : this.props.limiteMaximo}
                        onBlur={ (event) => this.handleBlur(event, event) } />
                </FormGroup>
                { (this.props.labelStatus && this.props.labelStatus.length>0) ? <Label className="label-danger">{ this.props.labelStatus }</Label> : "" }
                { this.state.alerta
                    && <Col xs={12} className="col-label label-obrigatorio px-0">
                        <Label>{ this.state.alerta }</Label>
                    </Col>
                }
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FormInputCNPJCPF.js